import { assertNever } from '@kofno/piper';
import { action, makeObservable, observable } from 'mobx';
import { getSearchParametersFromUrl, getUpdatedSearchParameters } from '../../../../../ListFilter';
import { SearchParameter } from '../../../../../ListFilter/Types';
import {
  ShareableLinksError,
  ShareableLinksResource,
  State,
  failed,
  loading,
  ready,
} from './Types';

class ShareableLinksStore {
  @observable
  state: State;

  constructor(id: string) {
    makeObservable(this);
    this.state = loading(id, getSearchParametersFromUrl());
  }

  @action
  ready = (resource: ShareableLinksResource) => {
    switch (this.state.kind) {
      case 'loading':
        this.state = ready(this.state, resource);
        break;
      case 'ready':
      case 'failed':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  fail = (error: ShareableLinksError) => {
    switch (this.state.kind) {
      case 'loading':
        this.state = failed(this.state, error);
        break;
      case 'ready':
      case 'failed':
        break;
      default:
        assertNever(this.state);
    }
  };

  // Links were generated, created or published on the page: read the list and
  // its counts again rather than patching them locally. Generating the first
  // links used to leave "0 out of 0" on screen until a manual reload (DVLP-8041).
  @action
  reload = () => {
    switch (this.state.kind) {
      case 'ready':
      case 'failed':
        this.state = loading(this.state.id, this.state.searchParameters);
        break;
      case 'loading':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  updatingSearchParameters = (searchParameter: SearchParameter) => {
    switch (this.state.kind) {
      case 'ready':
        this.state = loading(
          this.state.id,
          getUpdatedSearchParameters(
            { newSearchParameter: searchParameter, searchParameters: this.state.searchParameters },
            'deep_links_filter',
          ),
        );
        break;
      case 'loading':
      case 'failed':
        break;
      default:
        assertNever(this.state);
    }
  };
}

export default ShareableLinksStore;
